module.exports = __webpack_public_path__ + "static/media/temp_33.892103e3.jpg";